module.exports = __webpack_public_path__ + "static/brain-109e2b382c052aa18cff4a45ef7e2951.png";